import { render, staticRenderFns } from "./noticedetail.vue?vue&type=template&id=461e7096&scoped=true"
import script from "./noticedetail.vue?vue&type=script&lang=js"
export * from "./noticedetail.vue?vue&type=script&lang=js"
import style0 from "./noticedetail.vue?vue&type=style&index=0&id=461e7096&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461e7096",
  null
  
)

export default component.exports